import { SharedContent } from '../shared-content';

export const OpenChoiceCommonContent = {
  continueButton: SharedContent.buttons.continueButton,
  disclaimer: {
    part1:
      '<p>All investing is subject to risk, including the possible loss of the money that you invest.</p>',
    part2:
      '<p>Advice services are provided by Vanguard Advisers Inc., a registered investment advisor, or by Vanguard National Trust Company, a federally chartered, limited purpose trust company.</p> The services provided to clients will vary based upon the service selected, including management, fees, eligibility, and access to an advisor. ',
    linkText: "Find VAI's Form CRS and each program's advisory brochure here",
    linkHref: 'https://personal1.vanguard.com/ngf-next-gen-form-webapp/forms',
    part3:
      ' for an overview.</p><p>VAI and VNTC are subsidiaries of The Vanguard Group, Inc., and affiliates of Vanguard Marketing Corporation ("VMC"). Neither VAI, VNTC, nor its affiliates guarantee profits or protection from losses.',
  },
};
